export const awsConfig = {
  UserPoolId: 'us-east-1_6if60QREm',
  ClientId: '7gs0s4bfnngdjif6o0gg4kq268',  // Replace with your actual Client ID
  Region: 'us-east-1'  // Replace with your actual region if different
};

// If you need a default export as well, you can include this:
export default {
  cognito: awsConfig
  // Add other AWS configurations as needed
};